module.exports = __webpack_public_path__ + "static/img/2_11_2.6076c7fb.jpg";